import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getActiveTabFromLocalStorage } from "@/ui/TabsComponent/TabsComponent";

import { Page } from "@/ui/Layout/Page";
import { TabsComponent } from "@/ui/TabsComponent";
import Button from "@/ui/Button";
import { ButtonTypes, Variants } from "@/ui/types";
import { getCampaign } from "@/api/campaigns";
import { Settings } from "@/Apps/Dashboards/Settings/Settings";
import { getSessionToken } from "@/api/auth";
import { PublishCampaignModal } from "../Funnels/Popups/PublishCampaignModal";
import { CampaignBuilder } from "../Funnels";
// import { handleContentSave } from "./ContentEditor";

// const CollectionOverview = () => null;
// const CreateCollectionItem = () => null;

export const Dashboard = ({ name = "" }) => {
  const [activeTab, setActiveTab] = useState(getActiveTabFromLocalStorage() || "builder");
  const [collectionData, setCollectionData] = useState<{ name?: string }>({
    name: "",
  });
  const [isCollectionItemOpen, setIsCollectionItemOpen] =
     useState(false);
  const [activeObject, setActiveObject] = useState({});
  const [isLoading, setIsLoading] = useState(true);
 
  const [isPublishPopupOpen, setIsPublishPopupOpen] = useState(false);
  // const [activePageId, setActivePageId] = useState(null);
  const { id } = useParams();

  const handleOpenCollectionItem = (itemId) => {
    const item = collectionData?.objects?.filter(({ id }) => id === itemId)[0];
    console.log("item id", itemId, "item", item);
    setActiveObject(item);
    setIsCollectionItemOpen(true);
  };

  // Fetch the campaign data from the API when the component mounts
  useEffect(() => {
    const token = getSessionToken();

    (async () => {
      const data = await getCampaign({ token, id });
      setCollectionData(data);
      setIsLoading(false);
    })();
  }, []);

  // Use this to configure what shows in the top bar of the page
  const topBarSettings = {
    page: [
      { label: name, href: "/collections" },
      { label: collectionData.name || "•••", id, href: `/collections/${id}` },
    ],
    items: (
      <Button
        label="+ Create Collection Item"
        // onClick={() => setIsCollectionItemOpen(true)}
        onClick={() => handleOpenCollectionItem(null)}
        type={ButtonTypes.OUTLINED}
        variant={Variants.INFO}
      />
    ),
  };

  return (
    <Page topBar={topBarSettings}>
      {/* Render the publish campaign modal if it's set to open */}
      {isPublishPopupOpen && (
        <PublishCampaignModal
          setIsOpen={setIsPublishPopupOpen}
          campaignId={id}
          unitName="Collection"
        />
      )}
      {/* {isCollectionItemOpen && (
        <CreateCollectionItem
          setIsCollectionItemOpen={setIsCollectionItemOpen}
          activeObject={activeObject}
          unitName="Post"
          onChange={(newObject) => setActiveObject(newObject)}
          // onSave={() => handleContentSave(activeObject, id)}
          campaignId={id}
        />
      )} */}
      <div className={`p-6 w-full`}>
        {isLoading ? (
          <div>Loading...</div>
        ) : (
          <div className="tabs flex flex-col">
            <TabsComponent
              tabs={[
                // { label: "Content", value: "overview" },
                { label: "Visual Collection Builder", value: "builder" },
                { label: "Settings", value: "settings" },
              ]}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              actionSection={false}
            />
            {/* {activeTab === "overview" && (
              <CollectionOverview
                campaignData={collectionData}
                unitName="post"
                onOpenContentItem={handleOpenCollectionItem}
                onNewContentItem={() => handleOpenCollectionItem(null)}
              />
            )} */}
            {activeTab === "builder" && (
              <div className="h-[calc(100vh-174px)]">
                <CampaignBuilder id={id} campaignData={collectionData} />
              </div>
            )}
            {activeTab === "settings" && (
              <Settings
                campaignData={collectionData}
                setCampaignData={setCollectionData}
                unitName="Collection"
                widgets={["name", "delete"]}
              />
            )}
          </div>
        )}
      </div>
    </Page>
  );
};
